import { useState, useEffect } from 'react';

/**
 * Хук для получения отложенного значения (debounce).
 * @param value Значение, которое нужно отложить.
 * @param delay Задержка в миллисекундах.
 * @returns Отложенное значение.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Установить таймер для обновления значения после задержки
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Очистить таймер при размонтировании компонента или изменении значения/задержки
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]); // Перезапускать эффект только если значение или задержка изменились

  return debouncedValue;
} 